import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useState, useEffect } from 'react';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading, hasTabAccess } = useAuth();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );

  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    // Otherwise check authentication status
    if (!loading) {
      setIsAuthenticated(!!user);
    }
  }, [user, loading, location.state]);

  if (loading || isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Division secretaries are locked to the Division Portal. If they land on
  // any non-portal route (e.g. via deep link), bounce them to /portal so
  // they never see the admin chrome.
  if (user.role === 'division_secretary' && !location.pathname.startsWith('/portal')) {
    return <Navigate to="/portal" replace />;
  }

  // Check tab-level permission if required
  if (requiredPermission && !hasTabAccess(requiredPermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
